// FLAGS: none
// The five locale codes the app ships UI for, and nothing else. Nothing here reads or
// changes the active language: the post-sign-in switch that used to was never called, and the profile
// language is applied by `hooks/useProfileLanguage` since the path-prefix resolver landed.

export const LanguageCodeDutchNl = "nl-NL";
export const LanguageCodeEnglishGb = "en-GB";
export const LanguageCodeGermanDe = "de-DE";
export const LanguageCodeFrenchFr = "fr-FR";
export const LanguageCodeSpanishEs = "es-ES";
